import React from 'react';
import { AlertCircle } from 'lucide-react';

export default function SessionExpiredModal({ isOpen, onDismiss }) {
  // Don't show modal on login/public pages - only on protected pages
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
  const isPublicPage = ['/login', '/register', '/forgot-password', '/'].includes(currentPath);

  if (!isOpen || isPublicPage) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex items-center gap-3 mb-4">
          <AlertCircle className="h-6 w-6 text-amber-600" />
          <h2 className="text-xl font-bold text-gray-900">Session Expired</h2>
        </div>

        <p className="text-gray-600 mb-6">
          Your session has expired due to inactivity or you've been logged out from another location.
          Please log in again to continue.
        </p>

        <button
          onClick={onDismiss}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
        >
          Login Again
        </button>
      </div>
    </div>
  );
}
